import { o } from 'odata';
import authHub from '../authHub';
import errorHub from '../errorHub';

const odata = {
  o(rootGetters) {
    const token = rootGetters['app/getToken'];
    const currencyCode = rootGetters['currencies/getCurrency'];
    const budgetDocumentId = rootGetters['app/getBudgetDocumentId'];
    return o(`${process.env.VUE_APP_APIURL}/odata/`, this.getConf(token, currencyCode, budgetDocumentId));
  },
  getConf: (token, currencyCode, budgetDocumentId) => ({
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      CurrencyCode: `${currencyCode}`,
      Budgetdocumentid: budgetDocumentId,
    }),
    onError: (x, e) => {
      if (e.status === 401) {
        authHub.$emit('user.unauthorized');
      } else {
        errorHub.$emit('network.error', { x, e });
      }
    },
  }),
  parseId: (id) => {
    let i = id;
    if (Number.isNaN(id)) {
      i = `'${id}'`;
    }
    return i;
  },
};
export { odata };

export default {};
